
export default function(state=null,action){
    switch (action.type) {
      case "RESCHEDULE_REASONS":
          return action.payload;
      default: return state;
    }
  }
  
  


// WEBPACK FOOTER //
// ./src/reducer/get_reschedule_reason.js